// Warning : keep breakpoints on 2 char length
// or MHidden component won't support it.

// When you add a custom breakpoint,
// add it in MHidden PropTypes too.

const breakpoints = {
  values: {
    xs: 0, // small smartphones and smartwatches
    sr: 350, // regular smartphones
    sd: 420, // large smartphones (phablets)
    sm: 600, // smartphones landscape and tablet portrait
    md: 900, // tablet landscape
    lg: 1200, // small laptop
    xl: 1536, // large laptop and small desktop
    gt: 1920 // large desktop
  }
};

export default breakpoints;
